import CBuffer from 'CBuffer';
import nanoid from 'nanoid';
import config from '../config.js';

const initialState = {
    messages: new CBuffer(config.chat_buffer_size),
    userList: {},
    showUserList: false,
    loadingItialMessage: true,
    waitingForServer: false
}

function initChat(data) {
    const messages = initialState.filter(messages => data.chat.messages.map((message) => {
        message.id = nanoid(16);
        return message;
    }));

    initialState.messages.empty();
    initialState.messages.push().apply(initialState.messages, messages);

    initialState.userList = data.userList;
}


function userJoined(user){
    initialState.userList = initialState.userList[user.uname];
}

function userLeft(user) {
    delete initialState.userList[user.uname];
}

export default function chat(state=initialState, action) {
    switch(action.type){
        case 'INIT_CHAT':
         return initChat;
        case 'USER_JOINED':
         return userJoined();
        case 'USER_LEFT':
         return userLeft();
        case 'NEW_MESSAGE':
         return action.message;
        case 'SEND_MESSAGE':
         return action.text;
        case 'TOGGLE_USER_LIST':
         return {...state,
          showUserList: !state.showUserList
         };
        default:
          return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/chat.js